const trackerReducer = (state: any = {}, action) => {
  switch (action.type) {
    case "CREATE_TRACKER":
      let tracker = action.payload;
      return { ...state, tracker };
    case "TRACKER_LIST":
      let trackerList = action.payload;
      return { ...state, trackerList };
    case "TRACKER_LIST_REPORT":
      let trackerListReport = action.payload;
      return { ...state, trackerListReport };
    case "TRACKER_DELETE":
      if (state.trackerList && state.trackerList.length > 0) {
        let trackerList = state.trackerList.filter(
          (item) => item.id != action.payload.trackerId
        );
      }
      return { ...state, trackerList };
    default:
      return state;
  }
};

export default trackerReducer;
